import * as Yup from "yup";

export const SetPriceValidation = Yup.object({
  amount: Yup.number().positive().required("Required").min(1).label("amount"),
});
